import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Grid, Button, Input, Dropdown } from 'semantic-ui-react';
import moment from 'moment-timezone';
import { setPaymentReasonFilter, getPaymentReasonList } from 'actions/paymentReason';
import * as commonAction from 'actions/commons';
import { DateForm, Division } from '../Commons';

moment.tz.setDefault('Asia/Seoul');

const options = [
  { key: 'ALL', text: '전체', value: 'ALL' },
  { key: 'REGIST', text: '등록', value: 'REGIST' },
  { key: 'UNREGIST', text: '미등록', value: 'UNREGIST' }
];

class PaymentReasonForm extends Component {
  onChange = ({ target }) => {
    const { name, value } = target;
    const { paymentReasonAction } = this.props;
    paymentReasonAction.onFilterChange({ [name]: value });
  };

  onChangeDropDown = (e, { value }) => {
    const { paymentReasonAction } = this.props;
    paymentReasonAction.onFilterChange({ type: value });
  };

  onKeyUp = (e) => {
    if (e.keyCode === 13) {
      const { onSubmit } = this.props;
      onSubmit();
    }
  };

  render() {
    const { filter, division, onSubmit } = this.props;
    const { name, store, reason, type } = filter;
    return (
      <Form className="top-form" onSubmit={onSubmit}>
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group inline>
                <DateForm style={{ paddingLeft: 7 }} />
              </Form.Group>
            </Grid.Column>

            <Grid.Column width={2} className="form-right">
              <Button color="black" inverted style={{ width: '100%' }} content="조회" onClick={onSubmit} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group>
                <Form.Field inline>
                  <Form.Group inline>
                    <label htmlFor="name">이름</label>
                    <Input
                      placeholder="이름"
                      id="name"
                      name="name"
                      value={name}
                      onChange={this.onChange}
                      onKeyUp={this.onKeyUp}
                    />
                  </Form.Group>
                </Form.Field>
                <Form.Field inline>
                  <Form.Group inline>
                    <label htmlFor="store">가맹점</label>
                    <Input
                      placeholder="가맹점"
                      id="store"
                      name="store"
                      value={store}
                      onChange={this.onChange}
                      onKeyUp={this.onKeyUp}
                    />
                  </Form.Group>
                </Form.Field>
                <Form.Field inline>
                  <Form.Group inline>
                    <label htmlFor="reason">결제사유</label>
                    <Dropdown selection name="type" value={type} onChange={this.onChangeDropDown} options={options} />
                    <Input
                      placeholder="결제사유"
                      id="reason"
                      name="reason"
                      value={reason || ''}
                      onChange={this.onChange}
                      onKeyUp={this.onKeyUp}
                    />
                  </Form.Group>
                </Form.Field>
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group inline>
                <Division division={division} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export default connect(
  (state) => ({
    division: state.commons.division,
    filter: state.paymentReason.searchFilter
  }),
  (dispatch) => ({
    paymentReasonAction: bindActionCreators(
      {
        onFilterChange: setPaymentReasonFilter,
        getPaymentReasonList
      },
      dispatch
    ),
    cmAPI: bindActionCreators(
      {
        changeExcel: commonAction.ChangeExcel
      },
      dispatch
    )
  })
)(PaymentReasonForm);
